import { useTheme } from "@mui/material";
import { brandColors } from "../util";
import { useScreenWidth } from "hooks/useScreenWidth";
import { useMemo } from "react";

export function EnvBar() {
  const theme = useTheme();
  const { screenMaxWidth } = useScreenWidth();

  const viteEnvRaw = String(import.meta.env.VITE_ENV || "");
  const viteEnv = viteEnvRaw.toLowerCase();
  const color = useMemo(() => {
    switch (viteEnv) {
      case "release":
        return brandColors["encamp-orange"][
          theme.palette.mode === "dark" ? 600 : 400
        ];
      case "demo":
        return brandColors["encamp-blue"][
          theme.palette.mode === "dark" ? 700 : 200
        ];
      case "dev":
        return brandColors["encamp-green"][
          theme.palette.mode === "dark" ? 800 : 400
        ];
      default:
        return brandColors["encamp-purple"][
          theme.palette.mode === "dark" ? 700 : 300
        ];
    }
  }, [viteEnv, theme.palette.mode]);

  const label = viteEnvRaw
    ? viteEnvRaw.charAt(0).toUpperCase() + viteEnvRaw.slice(1)
    : "Unknown";

  return (
    <div
      style={{
        borderTop: `5px solid ${color}`,
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1,
        pointerEvents: "none",
      }}
    >
      <div style={{ maxWidth: screenMaxWidth, position: "relative" }}>
        <div
          id="env-display"
          style={{
            backgroundColor: color,
            borderRadius: "0 0 6px 6px",
            position: "absolute",
            right: 24,
            top: -5,
            fontSize: "0.8rem",
            padding: "1px 0.5rem",
            width: "fit-content",
            lineHeight: ".8",
            minWidth: "150px",
            textAlign: "center",
            fontWeight: "bold",
          }}
        >
          <span style={{ opacity: 0.9 }}>{label}</span>
        </div>
      </div>
    </div>
  );
}
